module.exports = __webpack_public_path__ + "img/news1.41d7fb2d.jpg";